import { useEffect, useState } from "react";
import { Column, Filters, useSortBy, useTable } from "react-table";
import { Child } from "../../../api/child";
import { Module } from "../../../api/module";
import IconSmArrowDown from "../../../Common/Icons/IconSmArrowDown";
import IconSmArrowUp from "../../../Common/Icons/IconSmArrowUp";
import { definitions } from "../../../api/supabase/client";

export interface ILessonDataRow {
  level: number;
  topic: string;
  module: string;
  date_created: string;
  created_by: string;
  completed: boolean;
  notion_url: string;
  fullModule: Module;
}

export interface IFeedbackDataRow {
  level: number;
  day: string;
  date: string;
  timeslot: string;
  assigned_teacher: string;
  progress: string;
  originalFeedback: definitions["TeacherFeedback"];
}

export interface IParentDashboardRow {
  avatar: any;
  name: string;
  course_name: string;
  course_start: string;
  course_end: string;
  level: number;
  onboarding_quiz: string;
  child: Child;
}

export interface ITable<T extends Object> {
  rowData: T[];
  colData: Column<T>[];
  onClickRow?: (row: T) => void;
  onSearch?: (newSearchVal: string) => Filters<T>;
}

// Define a custom filter filter function!
// function filterGreaterThan(rows, id, filterValue) {
//   return rows.filter(row => {
//     const rowValue = row.values[id]
//     return rowValue >= filterValue
//   })
// }

export default function Table<T extends Object>(props: ITable<T>) {
  const [search, setSearch] = useState("");
  const columns = props.colData;
  const data = props.rowData;

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setAllFilters,
  } =
    //TODO: Properly figure out columns datatype
    //@ts-ignore
    useTable<T>(
      { columns, data },
      //TODO: Figure out filters
      // , useFilters
      useSortBy
    );

  useEffect(() => {
    if (!props.onSearch) return;
    setAllFilters(props.onSearch(search));
  }, [props, search, setAllFilters]);

  return (
    <div className="overflow-y-scroll">
      {/* <div className="flex items-start justify-end gap-2.5 overflow-y-scroll h-full"> */}
      {/* {props.onSearch && (
          <div className="flex items-center justify-start gap-[5px]">
            <div className="h-[20px] w-[20px] fill-brij-Black rounded-2xl">
              <IconSearch />
            </div>
            <input
              className="text-small text-brij-Mud font-['Roboto'] leading-5"
              placeholder="Search"
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        )} */}
      {/* <button className="flex items-center justify-start gap-[5px]">
          <div className="h-[20px] w-[20px] fill-brij-Black rounded-2xl">
            <IconFilter />
          </div>
          <p className="text-small text-brij-Mud font-['Roboto'] leading-5">
            Filter
          </p>
        </button> */}
      {/* </div> */}
      <table className="table-auto w-full divide-y-2" {...getTableProps()}>
        <thead className="text-normal font-medium leading-[150%] h-12 sticky top-0 bg-brij-White z-10">
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  <div className="inline-flex justify-start items-center gap-2">
                    <p className="text-small text-left font-medium select-none">
                      {column.render("Header")}
                    </p>
                    <div>
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <IconSmArrowDown />
                        ) : (
                          <IconSmArrowUp />
                        )
                      ) : (
                        <div className="opacity-10 hover:opacity-50">
                          <IconSmArrowUp />
                        </div>
                      )}
                    </div>
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody
          className="divide-y-2 divide-brij-LightGrey"
          {...getTableBodyProps()}
        >
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr
                className="h-10 text-small cursor-pointer"
                onClick={(e) => {
                  props.onClickRow?.(row.original);
                }}
              >
                {row.cells.map((cell) => {
                  return <td>{cell.render("Cell")}</td>;
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
